import { useNavigate, useSearchParams } from 'react-router-dom';
import DngrEvalDetail from '../components/danger-evaluation/DngrEvalDetail';
import DngrEvalList from '../components/danger-evaluation/DngrEvalList';
import NavbarText from '../components/NavbarText';
import * as securityHelper from "../helper/SecurityHelper";

export default function DngrEval() {
  const navigate = useNavigate();
  const user = securityHelper.getLoginUser();
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get('tab') ?? 'list';
  const wrkDclrSeq = searchParams.get('seq');

  const goDetail = (seq: any) => setSearchParams({ tab: 'detail', seq: String(seq) });
  const goList = () => navigate(-1);
  const backEvent = () => navigate(-1);

  return (
      <div className='w-screen h-[calc(100dvh)] relative'>
        <NavbarText backEvent={backEvent}>위험성 평가서</NavbarText>
        {tab === 'list'
            ? <DngrEvalList auth={user.auth} goDetail={goDetail} />
            : <DngrEvalDetail wrkDclrSeq={wrkDclrSeq} goList={goList} />}
      </div>
  );
}
